























































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import PricingModel from '@services/PricingModel'
import ShoppingCartCardView from './ShoppingCartCardView'
import ShoppingCartTableView from './ShoppingCartTableView'
import ShoppingCartDiscountItems from './ShoppingCartDiscountItems'

settings =
  name: "ShoppingCartStep"

  vue:
    mixins: [WizardService.step()]
    components: { ShoppingCartCardView, ShoppingCartTableView, ShoppingCartDiscountItems }

    data: ->
      display: 'cards'

    methods:
      hiToggleDisplay: ->
        @display = if @display is 'cards' then 'table' else 'cards'

export default VueOptions.vue settings
